// Lightweight GA4 + Meta Pixel loader/wrapper.
// No-ops gracefully if the corresponding env var is missing,
// so the app works in local/dev without any tracking IDs.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '';

let initialized = false;

const injectScript = (src, attrs = {}) => {
  const s = document.createElement('script');
  s.async = true;
  s.src = src;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
  return s;
};

const loadGA = () => {
  if (!GA_ID || window.gtag) return;
  injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // We send page_view manually on route change so we can include the right path.
  window.gtag('config', GA_ID, { send_page_view: false });
};

const loadPixel = () => {
  if (!PIXEL_ID || window.fbq) return;
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
};

export const initAnalytics = () => {
  if (initialized || typeof window === 'undefined') return;
  loadGA();
  loadPixel();
  initialized = true;
};

export const trackPageView = (path) => {
  if (typeof window === 'undefined') return;
  if (window.gtag && GA_ID) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
  if (window.fbq && PIXEL_ID) {
    window.fbq('track', 'PageView');
  }
};

/**
 * Fire a purchase / Purchase conversion event.
 * @param {object} order  Order doc from /api/checkout/status (must include id, total, currency, items[]).
 */
export const trackPurchase = (order) => {
  if (!order || typeof window === 'undefined') return;
  const value = Number(order.total || 0);
  const currency = (order.currency || 'usd').toUpperCase();
  const items = (order.items || []).map((it, idx) => ({
    item_id: it.product_id || `item-${idx}`,
    item_name: it.name || `${it.brand || ''} ${it.model || ''}`.trim() || 'Appliance',
    item_brand: it.brand || undefined,
    price: Number(it.unit_price || 0),
    quantity: Number(it.qty || 1),
  }));

  if (window.gtag && GA_ID) {
    window.gtag('event', 'purchase', {
      transaction_id: order.id,
      value,
      currency,
      items,
    });
  }
  if (window.fbq && PIXEL_ID) {
    window.fbq('track', 'Purchase', {
      value,
      currency,
      contents: items.map(i => ({ id: i.item_id, quantity: i.quantity })),
      content_type: 'product',
      num_items: items.reduce((a, b) => a + b.quantity, 0),
    });
  }
};

export const analyticsEnabled = () => Boolean(GA_ID || PIXEL_ID);
